import gold from "./Images/gold.png";
import React, { useState, useEffect, useRef } from "react";

const Header = () => {
  const [sticky, setSticky] = useState(false);
  const [transparent, setTransparent] = useState(false);
  const inactivityTimer = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const isSticky = window.scrollY > 65;
      setSticky(isSticky);

      // Só ativa o efeito de sumir se não estiver na primeira seção
      if (isSticky) {
        resetInactivityTimer();
      } else {
        // Sempre visível na primeira seção
        setTransparent(false);
        clearTimeout(inactivityTimer.current);
      }
    };

    const resetInactivityTimer = () => {
      setTransparent(false); // Mostra navbar
      clearTimeout(inactivityTimer.current);
      inactivityTimer.current = setTimeout(() => {
        setTransparent(true); // Fica transparente
      }, 1000); // 5s sem interação
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("mousemove", () => {
      if (sticky) resetInactivityTimer();
    });
    window.addEventListener("keydown", () => {
      if (sticky) resetInactivityTimer();
    });

    handleScroll(); // Inicializa estado

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("mousemove", resetInactivityTimer);
      window.removeEventListener("keydown", resetInactivityTimer);
      clearTimeout(inactivityTimer.current);
    };
  }, [sticky]);

  return (
    <nav
      className={`navbar ${sticky ? "sticky" : ""} ${
        transparent ? "transparent" : ""
      }`}
    >
      <div className="menubars">
        <img className="imgicon1" src={gold} alt="Logo" />
        <h2 className="h2lheader">H2L Engenharia</h2>
      </div>
    </nav>
  );
};

export default Header;